/* eslint-disable import/no-cycle */
import React, {
  lazy, Suspense, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';

import CannotAccess from '../../../CannotAccess';
import {
  hasFeatureInLocalStorage,
  verifyFeatureAccess,
  verifyReceivedInboxAccess,
  verifyReferralManagementAccess,
} from '../../../../global/featureFlags';

const INBOX_REDESIGN_FLAG = 'inbox_redesign';

const LegacyReceivedRecords = lazy(() => import('../ReceivedRecords'));
const InboxRedesignPage = lazy(() => import('./RedesignPage'));

const InboxRedesignSwitch = (props) => {
  // Mirrors ReferralManagement gating: cached localStorage for first paint,
  // server flag converges after mount.
  const [redesignAccess, setRedesignAccess] = useState(
    () => hasFeatureInLocalStorage(INBOX_REDESIGN_FLAG) === true,
  );
  const [hasReceivedInboxAccess, setHasReceivedInboxAccess] = useState(null);
  const locationSearch = (props.location && props.location.search) || window.location.search;

  useEffect(() => {
    let isMounted = true;
    const urlParams = new URLSearchParams(locationSearch);
    const viewingReferralInbox = urlParams.get('referrals') === 'true';
    const verifyInboxAccess = viewingReferralInbox
      ? verifyReferralManagementAccess
      : verifyReceivedInboxAccess;

    (async () => {
      try {
        const [hasRedesignAccess, hasInboxAccess] = await Promise.all([
          verifyFeatureAccess(INBOX_REDESIGN_FLAG),
          verifyInboxAccess(),
        ]);
        if (isMounted) {
          setRedesignAccess(hasRedesignAccess === true);
          setHasReceivedInboxAccess(hasInboxAccess === true);
        }
      } catch {
        if (isMounted) {
          setRedesignAccess(false);
          setHasReceivedInboxAccess(false);
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [locationSearch]);

  if (!redesignAccess) {
    return (
      <Suspense fallback={null}>
        {React.createElement(LegacyReceivedRecords, props)}
      </Suspense>
    );
  }

  if (hasReceivedInboxAccess === null) return <div>Loading...</div>;
  if (!hasReceivedInboxAccess) return <CannotAccess />;

  return (
    <Suspense fallback={null}>
      {React.createElement(InboxRedesignPage, props)}
    </Suspense>
  );
};

InboxRedesignSwitch.defaultProps = {
  location: {},
};

InboxRedesignSwitch.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default InboxRedesignSwitch;
